import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY
);

const appearance = {
  theme: "stripe",
  variables: {
    colorPrimary: "#05e152",
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Elements
    stripe={stripePromise}
    options={{
      elementsOptions: { appearance },
    }}
  >
    <App />
  </Elements>
);
